
import { styled } from "@mui/system";
import { CircularProgress } from "@mui/material";

export default styled(CircularProgress)(({
    marginLeft: 10,
    color: "#ffffff"
}));